// reveal.js — IntersectionObserver scroll-in animations

import { scramble } from './scramble.js';

const CARD_STAGGER_MS = 90;

function observeSections() {
  const sections = document.querySelectorAll('.reveal-section');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  sections.forEach((el) => observer.observe(el));
}

function observeCards() {
  const cards = document.querySelectorAll('.reveal-card');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const card  = entry.target;
        const index = parseInt(card.dataset.index ?? '0', 10);

        setTimeout(() => {
          card.classList.add('visible');

          // Trigger scramble on card title
          const titleEl = card.querySelector('.scramble-target');
          if (titleEl) {
            scramble(titleEl, { duration: 800, delay: 0 });
          }
        }, index * CARD_STAGGER_MS);

        observer.unobserve(card);
      });
    },
    { threshold: 0.1 }
  );
  cards.forEach((el) => observer.observe(el));
}

export function initReveal() {
  observeSections();
  observeCards();
}
